import React, { useEffect, useMemo, useState } from "react";
import { EventListApi, GetDashboardCheckinCheckoutapi } from "../../../api/api";
import {
  MdOutlineCalendarMonth,
  MdOutlineLocationOn,
  MdWifiTethering,
} from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import { TbClock } from "react-icons/tb";
import { FaRegCirclePlay } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import TimeTakenChart from "../../../Components/Graphs/TimeTakenChart";
import { formatTime, getCompactTimeDifference } from "../../../utils/common";
import { FaRegUser } from "react-icons/fa";

function CheckinCheckoutDetails() {
  const navigate = useNavigate();
  const [event, setEvent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerData, setEmployeeData] = useState([]);
  const [customerDetails, setEmployeeDetails] = useState(null);
  const today = new Date();
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = today.toLocaleDateString("en-GB", options);
  const [activeFilter, setActiveFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showCustomFilter, setShowCustomFilter] = useState(false);

  const fetchEmployeeData = async () => {
    setLoading(true);
    try {
      const data = await GetDashboardCheckinCheckoutapi(startDate, endDate);
      if (data?.data?.status === true) {
        setEmployeeData(data?.data?.data);
        setEmployeeDetails({
          total: data?.data?.total_employees,
          total_checkin: data?.data?.total_checkins,
          total_checkout: data?.data?.total_checkouts,
        });
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const fecthEvents = async () => {
    setLoading(true);
    try {
      const data = await EventListApi();
      if (data?.data?.status === true) {
        setEvent(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthEvents();
    updateDateRange("daily");
    fetchEmployeeData();
  }, []);

  const updateDateRange = (filter) => {
    const today = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = today;
        break;
      case "weekly":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        end = today;
        break;
      case "monthly":
        start = new Date(today);
        start.setMonth(today.getMonth() - 1);
        end = today;
        break;
      default:
        start = end = today;
    }

    const format = (date) => date.toISOString().split("T")[0];
    setStartDate(format(start));
    setEndDate(format(end));
  };

  const columns = useMemo(
    () => [
      { accessorKey: "shape_type", header: "Shape of Event" },
      { accessorKey: "usecase_name", header: "Use Case" },
      { accessorKey: "restricted_type", header: "Restricted Side" },
      {
        accessorKey: "created_at",
        header: "Created At",
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
      },
    ],
    []
  );

  useEffect(() => {
    if (startDate && endDate) {
      fetchEmployeeData();
    }
  }, [startDate, endDate]);

  return (
    <div>
      <aside className="mainSection">
        <div className="p-5 bg-white">
          <h3 className="mb-4">CheckIn-CheckOut Monitoring</h3>
          <div className="customerDwellTime">
            <div className="itemsBox">
              <span>
                <IoCameraOutline size={26} />
              </span>
              <div className="">
                <h5>Camera</h5>
                <h3>Cash Counter</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineLocationOn size={26} />
              </span>
              <div className="">
                <h5>Location</h5>
                <h3>Cashier Area</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineCalendarMonth size={26} />
              </span>
              <div className="">
                <h5>Tracking</h5>
                <h3>{formattedDate}</h3>
              </div>
            </div>
            <div className="itemsBox" style={{ marginLeft: "auto" }}>
              <button
                className="eventModeBtn"
                onClick={() => navigate("/event-details")}
                style={{
                  backgroundColor: "red",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <MdWifiTethering size={18} />
                Live
              </button>
            </div>
          </div>
        </div>

        <div className="p-5 border-top">
          <div className="d-flex">
            <h4 className="">Employee Analyses</h4>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="customerAnalysesGrid">
                <div className="itemsBox">
                  <span>
                    <FaRegUser size={30} />
                  </span>
                  <div className="">
                    <h5>Total Employees</h5>
                    <div className="customer">
                      {customerDetails?.total || 800}
                      <p>Employees</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Check In</h5>
                    <div className="customer">
                      {customerDetails?.total_checkin || 40}
                      <p>Employees</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Check Out</h5>
                    <div className="customer">
                      {customerDetails?.total_checkout || 5}
                      <p>Employees</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Records</h5>
                    <div className="customer">
                      {customerData?.length}
                      <p>Records</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="filter-toggle-wrapper d-flex justify-content-end mb-3 flex-wrap">
                <div className="filter-toggle-group">
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "daily" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("daily");
                      updateDateRange("daily");
                    }}
                  >
                    Daily
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "weekly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("weekly");
                      updateDateRange("weekly");
                    }}
                  >
                    Weekly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "monthly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("monthly");
                      updateDateRange("monthly");
                    }}
                  >
                    Monthly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "custom" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("custom");
                      updateDateRange("custom");
                      setShowCustomFilter(true);
                    }}
                  >
                    Custom
                  </button>
                </div>
                {activeFilter === "custom" && showCustomFilter && (
                  <div className="d-flex gap-3 align-items-center mb-3 flex-wrap custom-date-wrapper p-3 bg-light rounded">
                    <div>
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customStart}
                        onChange={(e) => setCustomStart(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customEnd}
                        onChange={(e) => setCustomEnd(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        className="btn btn-primary mt-4"
                        onClick={() => {
                          setStartDate(customStart);
                          setEndDate(customEnd);
                          setShowCustomFilter(false); // hide after apply
                        }}
                        disabled={!customStart || !customEnd}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <TimeTakenChart />
            </div>
          </div>

          <div className="mt-5 cstTableCls">
            <table className="table rounded-3 border">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Employees</th>
                  <th>Time Length</th>
                  <th>Entered</th>
                  <th>Exited </th>
                  <th>Video</th>
                </tr>
              </thead>
              <tbody>
                {customerData?.map((customer, index) => (
                  <tr key={index}>
                    <td>
                      {/* <img src="../images/camImg.png" alt="cameraImage" /> */}
                      <img
                        src={
                          "https://visionemptrack.greymatterz.com/" +
                          customer?.employee_image
                        }
                        alt="cameraImage"
                        className="img-fluid rounded"
                        width={70}
                      />
                    </td>
                    <td>{customer?.employee_name}</td>
                    <td>
                      {getCompactTimeDifference(
                        customer?.first_checkin_time,
                        customer?.last_checkout_time
                      )}{" "}
                    </td>
                    <td>{formatTime(customer?.first_checkin_time)}</td>
                    <td>{formatTime(customer?.last_checkout_time)}</td>
                    <td>
                      <Link className="videoLink">
                        <FaRegCirclePlay size={22} /> Play Video
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default CheckinCheckoutDetails;
